import tagsService from '../service/tagsService'
export const TAGS_CHANGE = 'TAGS_CHANGE'

export const LOAD_TAGS_START = 'LOAD_TAGS_START'
export const LOAD_TAGS_SUCCESS = 'LOAD_TAGS_SUCCESS'
export const LOAD_TAGS_FAILURE = 'LOAD_TAGS_FAILURE'

export const loadTagsStart = () => ({
  type: LOAD_TAGS_START
})

export const loadTagsSuccess = ({ tags }) => ({
  type: LOAD_TAGS_SUCCESS,
  payload: {
    tags
  }
})

export const loadTagsFailure = ({ error }) => ({
  type: LOAD_TAGS_FAILURE,
  payload: {
    error
  }
})

export const loadAllTagsDataAsync =
  () =>
  (dispatch) => {
    dispatch(loadTagsStart())


    tagsService
      .getAllTagsData()
      .then((result) => {
        const tags = result.data
        dispatch(loadTagsSuccess({ tags }))
      })
      .catch((error) => {
        dispatch(loadTagsFailure({ error: '' }))
        console.error(error)
      })
  }
